// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__qcF3p","title":"NavBar_title__eVMDS","profile":"NavBar_profile__oLLA+","hold":"NavBar_hold__kNZSa"};